import React from 'react';
import PropTypes from 'prop-types';
import bgImage from 'images/banner-bg-grid.png';

function Banner({ image, title, main, callToAction }) {
  return (
    <div className="ad-banner--container" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="ad-banner--inner">
        <img src={image} alt="banner icon" />
        <div className="ad-banner--main-title">
          <div className="text-22 text-red">{title}</div>
          <div className="ad-banner--main-body">{main}</div>
        </div>
        {callToAction && <div className="ad-banner--inner-button">{callToAction}</div>}
      </div>
    </div>
  );
}

Banner.propTypes = {
  title: PropTypes.string,
  main: PropTypes.string,
  image: PropTypes.string,
  callToAction: PropTypes.node
};

export default Banner;
